import { useSyncExternalStore } from "react";

export const ASSIGN_HINT = "Kannst du jederzeit im Menü ändern.";

let promptGroupId = null;
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const setPromptGroupId = (groupId) => {
  if (promptGroupId === groupId) return;
  promptGroupId = groupId;
  listeners.forEach((listener) => listener());
};

export const promptAssignment = (groupId) => setPromptGroupId(groupId);

export const clearAssignmentPrompt = () => setPromptGroupId(null);

export const isAssignmentPromptPending = () => promptGroupId !== null;

const getSnapshot = () => promptGroupId;

export const useAssignmentPrompt = () =>
  useSyncExternalStore(subscribe, getSnapshot);
